import { Icon } from "../../components/Icon";
import { COMPANY } from "../../config/company";
import { CompanyLayout, InfoSection, SafetyNote, Tile } from "./CompanyLayout";

const MAP_QUERY = encodeURIComponent(COMPANY.registeredAddress);

export function ContactPage() {
  return (
    <CompanyLayout
      path="/contact"
      eyebrow="Phone & office"
      title="Talk to a person."
      intro={
        <>
          Call us during support hours, {COMPANY.supportHours}. Outside those
          hours, the assistant on WhatsApp is always on, and email reaches us
          any time.
        </>
      }
      aside={
        <div className="email-card">
          <span className="email-card__label">Phone</span>
          <a className="email-card__address" href={`tel:${COMPANY.phone}`}>
            {COMPANY.phoneDisplay}
          </a>
          <div className="email-card__actions">
            <a className="btn btn-dark" href={`tel:${COMPANY.phone}`}>
              <Icon name="call" size={18} />
              Call now
            </a>
            <a className="btn btn-ghost" href="/support">
              Email instead
            </a>
          </div>
          <span className="email-card__hours">
            <Icon name="clock" size={16} />
            {COMPANY.supportHours}
          </span>
        </div>
      }
    >
      <InfoSection
        title="When to call"
        lede="A call is quickest when something is urgent."
      >
        <div className="tile-grid">
          <Tile icon="lock" title="Lost or stolen phone">
            Call and we’ll lock your Hethera account so nobody can pay with it.
            Then follow up by email from any device to set a new PIN.
          </Tile>
          <Tile icon="card" title="A charge you don’t recognise">
            Tell us straight away. Have the date and amount from your bank
            statement ready.
          </Tile>
          <Tile icon="refund" title="A refund that hasn’t arrived">
            Most problems are faster by <a href="/support">email</a>, with the
            reference from your receipt, so we can check the payment before we
            reply.
          </Tile>
        </div>
        <SafetyNote />
      </InfoSection>

      <InfoSection
        title="Registered office"
        lede="Our address as recorded by the Corporate Affairs Commission."
      >
        <div className="office">
          <address className="office__card">
            <Icon name="pin" size={24} />
            <strong>{COMPANY.legalName}</strong>
            <span>{COMPANY.address.street}</span>
            <span>
              {COMPANY.address.locality}, {COMPANY.address.region}
            </span>
            <span>Nigeria</span>
            <span className="mono office__rc">RC {COMPANY.rcNumber}</span>
            <a
              className="btn btn-ghost"
              href={`https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Open in Google Maps
              <Icon name="arrow" size={16} />
            </a>
          </address>
          <div className="office__note">
            <h3>Visiting?</h3>
            <p>
              This is our registered office, not a walk-in service centre.
              Please email{" "}
              <a href={`mailto:${COMPANY.supportEmail}`}>
                {COMPANY.supportEmail}
              </a>{" "}
              to arrange a visit, and send letters or legal notices to this
              address marked for the attention of the directors.
            </p>
          </div>
        </div>
      </InfoSection>
    </CompanyLayout>
  );
}
